<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 17.8333C12.6041 17.8333 13.0937 17.3436 13.0937 16.7396C13.0937 16.1355 12.6041 15.6458 12 15.6458C11.3959 15.6458 10.9062 16.1355 10.9062 16.7396C10.9062 17.3436 11.3959 17.8333 12 17.8333ZM12 6.82499C10.0513 6.82499 8.28332 8.22915 8.28332 10.1771V10.5417C8.28332 10.9835 8.6415 11.3417 9.08332 11.3417C9.52515 11.3417 9.88333 10.9835 9.88333 10.5417V10.1771C9.88333 9.30677 10.7276 8.42499 12 8.42499C13.2724 8.42499 14.1167 9.30677 14.1167 10.1771C14.1167 11.0474 13.2724 11.9292 12 11.9292C11.5582 11.9292 11.2 12.2873 11.2 12.7292V13.4583C11.2 13.9002 11.5582 14.2583 12 14.2583C12.4418 14.2583 12.8 13.9002 12.8 13.4583V13.4497C14.4072 13.1272 15.7167 11.8535 15.7167 10.1771C15.7167 8.22915 13.9487 6.82499 12 6.82499Z"
    />
  </svg>
</template>
